export const parisLandmarks = [
  {id:0,name:'Eiffel Tower',area:'Champ de Mars',x:-29,z:21,width:19,depth:22,description:'An open iron lattice tower above formal gardens and promenades.'},
  {id:1,name:'Arc de Triomphe',area:'Étoile',x:-30,z:-22,width:20,depth:20,description:'A monumental arch with sculpted piers and a paved arrival plaza.'},
  {id:2,name:'Louvre Palace',area:'Cour Napoléon',x:32,z:-22,width:27,depth:22,description:'Mansard-roof palace wings framing a glass pyramid courtyard.'},
  {id:3,name:'Notre-Dame',area:'Île de la Cité',x:0,z:0,width:13,depth:31,description:'Twin stone towers, a rose window and flying buttresses on a river island.'},
  {id:4,name:'Sacré-Cœur',area:'Montmartre',x:31,z:22,width:24,depth:25,description:'Ivory domes above a terraced hillside and a broad garden staircase.'},
] as const
export const parisAddresses:Record<number,[number,number]> = {
  1:[-49,-46],3:[-49,-29],6:[-49,-15],8:[-49,7],9:[-49,20],11:[-49,31],13:[-49,46],
  14:[49,-46],16:[49,-29],18:[49,-15],19:[49,7],21:[49,20],23:[49,31],24:[49,46],
  26:[-34,-47],27:[-21,-47],29:[21,-47],31:[35,-47],33:[-34,47],34:[-21,47],36:[21,47],38:[35,47],
}
export const parisTileNames:Record<number,string>={
  0:'BIENVENUE',1:'RUE CLER',3:'RUE DE BUCI',5:'MÉTRO',6:'RUE MOUFFETARD',8:'RUE MONTORGUEIL',9:'RUE DES MARTYRS',
  10:'LUXEMBOURG',11:'SAINT-GERMAIN',13:'SAINT-MICHEL',14:'RUE DE RIVOLI',15:'MÉTRO',16:'AVENUE DE SÉGUR',18:'RUE DE RENNES',19:'RUE DE PASSY',
  20:'FÊTE DE PARIS',21:'AVENUE FOCH',23:'AVENUE VICTOR HUGO',24:'AVENUE KLEBER',25:'MÉTRO',26:'AVENUE MONTAIGNE',27:'RUE SAINT-HONORÉ',29:'FAUBOURG HONORÉ',
  30:'TUILERIES',31:'BOULEVARD HAUSSMANN',33:'AVENUE DE L’OPÉRA',34:'PLACE VENDÔME',35:'MÉTRO',36:'CHAMPS-ÉLYSÉES',38:'QUAI VOLTAIRE',
}
export function parisPropertyPosition(id:number):[number,number]{
  if(id<100){const p=parisLandmarks[id];return [p.x,p.z]}
  return parisAddresses[id-100]??[0,0]
}
export function parisLanePose(time:number,index:number,lane:number){
  const p=((index/8+time*2.5/110)%1+1)%1,direction=Math.sign(lane)*(Math.abs(lane)<13.5?1:-1)
  return {x:lane,z:(p-.5)*110*direction,angle:direction<0?Math.PI:0,scale:Math.min(1,p*30,(1-p)*30)}
}
export function parisBoatPose(time:number,index:number){
  const p=((Math.floor(index/2)/3+time*.7/112)%1+1)%1,direction=index%2?1:-1
  return {x:direction*8.25,z:(p-.5)*112*direction,angle:direction<0?Math.PI:0,scale:Math.min(1,p*25,(1-p)*25)}
}
// Keep context blocks out of river, streets, landmark grounds and owned parcels.
export function parisContextSites(){
  const sites:{x:number;z:number;style:number}[]=[]
  for(const x of [-40,-33,-26,-19,19,26,33,40])for(let z=-46;z<=46;z+=7.7){
    if(Math.abs(z)<5||Math.abs(z-37)<5||Math.abs(z+37)<5)continue
    if(parisLandmarks.some(l=>Math.abs(x-l.x)<l.width/2+2.9&&Math.abs(z-l.z)<l.depth/2+2.9))continue
    if(Object.values(parisAddresses).some(([px,pz])=>Math.abs(x-px)<5.8&&Math.abs(z-pz)<5.8))continue
    sites.push({x,z,style:sites.length%7})
  }
  return sites
}
